import WorklistComponent from "~/components/pages/supervisor/worklist";

export default function WorklistPage() {
  return (
    <div>
      <WorklistComponent />
    </div>
  );
}
